export default "__VITE_ASSET__SxZjXJeq__"